<div class="wt-steps-bar-item" [class.wt-steps-bar-item--active]="isActive">
  <label class="wt-text-base-m wt-steps-bar-item__label" *ngIf="(isActive && showActiveLabel) || showAllLabels">{{ label }}</label>
  <div class="wt-steps-bar-item__progress"></div>
</div>
